module.exports = __webpack_public_path__ + "media/assets/images/rw-modal-02-eb3a7526df46b9dc19897112eaff73c5.jpg";